module.exports = __webpack_public_path__ + "img/feedback.4080a39a.svg";